import {HttpInterceptorFn} from '@angular/common/http';
import {addBreadcrumb, Breadcrumb} from '@sentry/angular';
import {config} from "../../../config";
import {tap} from "rxjs";

export const sentryTracePropagationInterceptor: HttpInterceptorFn = (req, next) => {

  const url = req.url;
  if (!url.startsWith(config.endpoints.api)) {
    return next(req);
  }

  return next(req).pipe(
    tap({
      next: () => {
        return;
      },
      error: err => {
        const breadcrumb = {
          type: 'http',
          category: 'fetch',
          data: {
            url: req.url,
            method: req.method,
            headers: req.headers.keys().reduce((acc, key) => {
              acc[key] = req.headers.get(key);
              return acc;
            }, {} as Record<string, string|null>),
            status_code: err.status,
            body: err.error
          },
          level: 'debug'
        } satisfies Breadcrumb;
        addBreadcrumb(breadcrumb);
      }
    })
  );
};
